<template>
  <div style="background: black; margin-left: -1em; margin-right: -1em">
    <b-row>
      <b-col id="welcome-container">
        <div id="background-image-container">
          <!--          <b-img id="background-image" fluid-grow src="../assets/road-layers 1500px.jpg" />-->
          <b-img id="background-image" fluid-grow src="../assets/px-road-layers-75pct.jpg" />
          <!--        <div id="background-image"-->
          <!--             align-v="center"-->
          <!--             align-h="center"-->
          <!--             style="display: flex; align-items: center; justify-content: center;">-->
          <!--             &lt;!&ndash;        <b-button v-if="!userIsLoggedIn" variant="success" style="opacity: 1;">&ndash;&gt;-->
          <!--             &lt;!&ndash;          Login&ndash;&gt;-->
          <!--             &lt;!&ndash;        </b-button>&ndash;&gt;-->
          <!--        </div>-->
          <div id="welcome">
            <b-card style="text-align: center">
              Welcome to

              <b-img src="@/assets/img-ui/PX-logo_white-green.png" height="30px" />

              <div>
                <b-button v-if="!userIsLoggedIn"
                          v-b-modal.login-modal
                          class="mr-3"
                          variant="success">
                  <font-awesome-icon :icon="['fas','user']" />
                  Login
                </b-button>

                <b-button v-if="!userIsLoggedIn"
                          to="newUser"
                          variant="info">
                  <font-awesome-icon :icon="['fas','user']" />
                  Create Account
                </b-button>
              </div>
            </b-card>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>


  import { userStore } from '@/store/store';
  import { Component, Vue } from 'vue-property-decorator';

  @Component
  export default class Home extends Vue {
    get userIsLoggedIn() {
      return userStore.userIsLoggedIn;
    }

    mounted() {
      // Redirect to projects if the user is logged in so they don't just sit on a splash page.
      if (this.userIsLoggedIn) {
        this.$router.push('/projects');
      }
    }
  }

</script>

<style scoped lang="scss">
  @import './../scss/custom.scss';

  #welcome-container {
    display: flex; 
    align-items: center; 
    justify-content: center;
  }

  #background-image-container {

    position: relative;;
    /*background: black url('../assets/road-layers 1500px.jpg') no-repeat center center fixed;*/
    background: black;
    width: 100%;
    /*-webkit-background-size: cover;*/
    /*-moz-background-size: cover;*/
    /*-o-background-size: cover;*/
    /*background-size: cover;*/
    /*height: 1000px;*/
  }
  
  #background-image{
    opacity: .9;
  }

  #welcome {
    margin: auto;
    position: absolute;
    transform: translate(-50%, -50%);
    top: 30%;
    left: 50%;

    font-size: 2em;

    .card-body {
      background: $color-px-dark;
      color: $color-px-light;
    }

  }


</style>
